export default function Footer(){
return(
    <>
    <div className="contain footer">
        <div className="topHalf">      
<p>Developed by Dharuv Manchanda © All rights reserved.
</p>       
        <div className="rightHalf">
            <a href="#"><i class="fa-brands fa-facebook"></i></a>
            <a href="#"><i class="fa-brands fa-twitter"></i></a>
            <a href="#"><i class="fa-brands fa-instagram"></i></a>
            <a href="#"><i class="fa-brands fa-whatsapp"></i></a>
        </div>
        </div>
            <div className="bottomHalf">
<div className="firstHalf">
    <h1>DPD IELTS</h1>
    <p>No.1 IELTS and PTE Institute in Place with Cutting Edge Teaching Technologies and methodologies.</p>
</div>
<div className="secondHalf">
  <ul>
    <h4>Quick Links</h4>
    <li>About Us</li>
    <li>IELTS</li>
    <li>Pearson PTE</li>
    <li>CD-IELTS</li>
    <li>ContactUs</li>
  </ul>
</div>
<div className="thridHalf">
<ul>
    <h4>Quick Links</h4>
    <li>About Us</li>
    <li>IELTS</li>
    <li>Pearson PTE</li>
    <li>CD-IELTS</li>
    <li>ContactUs</li>
  </ul>
</div>
<div className="fourHalf">
<ul>
    <h4>Our Adress</h4>
    <li><a href="#"><i class="fa-solid fa-location-crosshairs"></i>Sunami Gate Sangrur</a></li>
    <li><a href="#"><i class="fa-regular fa-clock"></i>Open 10 to 10</a></li>
    <li><a href="#"><i class="fa-solid fa-envelope-open"></i>send mail at @gmail</a></li>
    </ul>
    <a href="/contact" className="secondary-btn lB">Get in Touch</a>
</div>
            </div>
    </div>
    </>
)
}